import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const PropertyIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 45 45" fill="none" {...props}>
    {/* Outer circle */}

    <path
      d="M22.5 0.75C34.5122 0.75 44.25 10.4878 44.25 22.5C44.25 34.5122 34.5122 44.25 22.5 44.25C10.4878 44.25 0.75 34.5122 0.75 22.5C0.75 10.4878 10.4878 0.75 22.5 0.75Z"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.5"
      fill="none"
    />

    {/* Window / upper detail */}

    <path
      d="M28.7298 27.9163V23.583H24.8965V27.9163H28.7298ZM25.8548 24.6663H27.7715V26.833H25.8548V24.6663ZM20.584 26.8113V28.978L21.5423 28.4363V26.8113H20.584Z"
      fill="currentColor"
    />

    {/* House / garage structure */}

    <path
      d="M31.6048 20.8747V19.7913L29.209 14.3747H26.8131V12.208L25.8548 12.7497V14.3747H15.7923L13.3965 19.7913V32.7913H31.6048V21.958L30.6465 22.4997V31.708H22.9798V26.833C22.9798 25.8274 22.6264 24.863 21.9974 24.1519C21.3684 23.4408 20.5152 23.0413 19.6256 23.0413C18.7361 23.0413 17.8829 23.4408 17.2539 24.1519C16.6249 24.863 16.2715 25.8274 16.2715 26.833V31.708H14.3548V20.8747H31.6048ZM17.2298 26.833C17.2298 26.1147 17.4822 25.4258 17.9315 24.9179C18.3808 24.41 18.9902 24.1247 19.6256 24.1247C20.2611 24.1247 20.8705 24.41 21.3198 24.9179C21.7691 25.4258 22.0215 26.1147 22.0215 26.833V31.708H17.2298V26.833ZM16.3913 15.458H28.6196L30.5363 19.7913H14.4842L16.3913 15.458Z"
      fill="currentColor"
    />
  </SvgIcon>
);
